import { MutableRefObject, useEffect } from 'react';

/**
 * Hook to execute callback on outside DOM element click.
 * @param ref - ref to element.
 * @param outsideClickCallback - outside click callback.
 */
export const useOutsideClickHandler = (ref: MutableRefObject<any>, outsideClickCallback: () => void): void => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    const handleClickOutside = (event): void => {
      if (ref.current && !ref.current.contains(event.target)) {
        outsideClickCallback();
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
};
